import React from "react";
import NumberFormat from "react-number-format";
import CurrencyDisplay from "../../shared/currency-display";
import HelpText from "../../shared/help-text";
import BackgroundCharacter from "./background-character";

function BackgroundCharacters(props) {
  const {
    budget,
    items,
    onChangeBuget,
    onChangeDays,
    showHide,
    visible,
    total,
    readOnly,
    filmId,
    saving
  } = props;

  return (
    <div>
      <div className="columns subtitle is-4 mt-1">
        <div className="column is-two-thirds">
          <h4
            className="subtitle is-4 pointer"
            onClick={() => showHide(!visible)}>
            <button className="button is-text is-small">
              {!visible && <i className="material-icons">add</i>}
              {visible && <i className="material-icons">remove</i>}
            </button>
            Background Characters
          </h4>
        </div>
        <div className="column is-one-third budget-header-number">
          <CurrencyDisplay
            value={total}
          />
        </div>
      </div>
      {visible && (
        <>
          <table className="table budget-table">
            <thead>
              <tr>
                <th>Name</th>
                <th className="budget-days-column">Days</th>
                <th className="budget-daily-rate-column">Budget</th>
                <th className="has-text-centered">Quantity</th>
                <th className="has-text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              {(items || []).map((item, i) => {
                return (
                  <BackgroundCharacter
                    key={i}
                    item={item}
                    onChangeBuget={onChangeBuget}
                    onChangeDays={onChangeDays}
                    maxDays={budget.days}
                    totalScenes={budget.totalScenes}
                    hasShootingDays={budget.hasShootingDays}
                    readOnly={readOnly}
                    filmId={filmId}
                    saving={saving}
                  />
                );
              })}
              <tr>
                <td colSpan={4}></td>
                <td className="has-text-right">
                  <CurrencyDisplay
                    value={total}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}

export default BackgroundCharacters;
